/** How member names are shown across Recovery Commons (first name + last initial). Catalog keys. */

export const DISPLAY_NAME_LABEL_KEY = 'auth.display_name.label';
export const DISPLAY_NAME_PLACEHOLDER_KEY = 'auth.display_name.placeholder';
export const DISPLAY_NAME_HINT_KEY = 'auth.display_name.hint';
